// extracted by mini-css-extract-plugin
module.exports = {"lockingNumberBlocker":"lockingNumberBlocker__lockingNumberBlocker2xA","spin":"lockingNumberBlocker__spinpxf","lockingNumberBg":"lockingNumberBlocker__lockingNumberBg3zK"};